var filter = {
  data() {
    return {
      filter: {}
    }
  },
  methods: {
    collectFilter(params = {}) {
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] !== null && this.filter[key] !== '') {
          params[key] = this.filter[key]
        }
      })
      return params
    }
  }
}

export default filter
